import React, { useState } from "react";
import TeacherAssignTable from "./TeacherAssignTable";

const TeacherAssign = () => {
  const [canUpdate, setCanUpdate] = useState(true);
  const [canDelete, setCanDelete] = useState(true);

  return (
    <div className="page-top-div">
      <span className="text-span">Badge Manager</span>
      <TeacherAssignTable canUpdate={canUpdate} canDelete={canDelete} />
    </div>
  );
};

export default TeacherAssign;
